export enum ResponseError {
    UNAUTHORIZED,
    UNEXPECTED,
    UNAVAILABLE,
}
